<ng-container *ngIf="disableCopyOnHover; else copyOnHover">
  <span [class.text-placeholder]="!orderLine">{{ name }}</span>
</ng-container>
<ng-template #copyOnHover>
  <span [class.text-placeholder]="!orderLine" [tcCopyOnHover]="[name]">{{ name }}</span>
</ng-template>
